<template>
  <div class="document">
    <h1 class="title is-3">Vielen Dank für deine Registrierung.</h1>
    <h2 class="title is-5">
      Du wirst in kürze eine E-Mail mit weiteren Informationen erhalten.
    </h2>
  </div>
</template>

<script>
export default {
  name: "NextSteps"
};
</script>

<style scoped lang="scss">
.document {
  text-align: center;
}
</style>
